<template>
	<tr class="c-signee">
		<td>
			<div class="d-flex align-items-center">
				<div v-if="player.image" class="c-signee__image">
					<img :src="player.image + '?width=60'" alt="image" />
				</div>
				<div class="c-signee__name font-size-21 line-height-125">
					<a
						v-bind:href="'/roster.aspx?rp_id=' + player.id"
						class="c-card__link"
					>
						{{ player.fullname }}
					</a>
				</div>
			</div>
		</td>
		<td class="c-signee__table--position">
			{{ player.position_short.toUpperCase() }}
		</td>
		<td class="font-size-16 line-height-125">
			{{ player.signingtime ? player.signingtime : 'N/A' }}
		</td>
		<td class="font-size-16 line-height-125">
			{{ player.player_hometown }}
		</td>
		<td>
			<a
				class="c-signee__moreinfo font-size-14 line-height-125"
				v-bind:href="'/roster.aspx?rp_id=' + player.id"
				>Bio</a
			>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'SigneeRow',
	props: {
		player: Object,
	},
	data: () => ({}),
	methods: {},
	computed: {},
};
</script>

<style scoped lang="scss">
.c-signee {
	td {
		padding: 20px 24px;
		box-shadow: inset 0px -1px 0px $main-border-color;
		background: $main-color;
		text-align: center;
		color: $main-font-color;
		&:first-child {
			text-align: left;
			font-weight: 700;
			a {
				color: $main-font-color;
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
	&__image {
		width: 60px;
		height: 60px;
		flex-shrink: 0;
		border-radius: 50%;
		overflow: hidden;
		margin-right: 24px;
	}
	&__moreinfo {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		margin: 0 auto;
		font-weight: 700;
		text-transform: uppercase;
		width: 69px;
		height: 35px;
		background: var(--color-primary);
		color: var(--text-on-primary);
		text-decoration: none;
		transition: 0.25s;
	}
}
</style>
